import { Dialog, IconButton, Stack } from "@mui/material";
import { CustomTextView } from "./CustomTextView";
import { useTranslation } from "react-i18next";
import { CloseRounded } from "@mui/icons-material";
import { COLOR_MAIN, COLOR_WHITE } from "../../data/colors/Colors";
import { Rating } from "react-simple-star-rating";
import { useEffect, useState } from "react";
import { CustomTextField } from "./CustomTextField";
import { CustomButtonView } from "./CustomButtonView";

interface DialogProps {
  open: boolean;
  onClose: () => void;
  onRateGiven: (rate: number, feedback?: string) => void;
}

export const GiveFeedbackDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  onRateGiven,
}: DialogProps) => {
  const { t } = useTranslation();

  const [feedback, setFeedback] = useState<string | undefined>();
  const [rating, setRating] = useState<number | undefined>();

  useEffect(() => {
    if (open) {
      setRating(undefined);
      setFeedback(undefined);
    }
  }, [open]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ style: { borderRadius: 16, minWidth: "50vw" } }}
    >
      <Stack gap={2} alignItems={"center"}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          width={"100%"}
          justifyContent={"space-between"}
          sx={{ bgcolor: COLOR_MAIN }}
          p={2}
        >
          <CustomTextView
            text={t("rating")}
            fontWeight="bold"
            variant="h5"
            textColor={COLOR_WHITE}
          />
          <IconButton onClick={onClose}>
            <CloseRounded sx={{ color: COLOR_WHITE }} fontSize="large" />
          </IconButton>
        </Stack>
        <Stack width={"100%"} p={2} alignItems={"center"} gap={4}>
          <Rating onClick={(rate) => setRating(rate)} size={45} transition />
          {rating && (
            <Stack width={"100%"}>
              <CustomTextField
                value={feedback}
                placeholder={t("feedback")}
                onTextChange={(txt) => {
                  setFeedback(txt);
                }}
                isFullWidth
              />
            </Stack>
          )}
          <Stack width={"100%"}>
            <CustomButtonView
              text={t("submit")}
              fontSize="h6"
              disabled={!rating}
              onClick={() => {
                if (!rating) return;
                onRateGiven(rating, feedback);
                onClose();
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};
